import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ElementRef } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { FilesManagerService } from '../../../services/files-manager.service';
import { OverlayService } from '../../../services/overlay.service';
import { ComponentService } from '../../../services/component.service';

const FILE_UPLOAD_DROPDOWN_MAX_HEIGHT = 91;
const IMAGE_UPLOAD_MAX_SIZE = 1200;
@Component({
	selector: 'app-file-field',
	templateUrl: './file-field.component.html',
	styleUrls: ['./file-field.component.scss']
})
export class FileFieldComponent implements OnInit {
	@ViewChild('fileManagerModal', { static: false }) public fileManagerModal: ModalDirective;
	// eslint-disable-next-line @angular-eslint/no-output-on-prefix
	@Output() onModelChange = new EventEmitter<any>();
	@Input() model;
	@Input() invalid;
	@Input() invalidMessage;
	@Input() allowedType;
	@Input() allowedDimensions;
	@Input() optional;
	@Input() formScrollProp: any;
	@Input() limitations: any;
	@Input() public uniqueID: string;
	@ViewChild('dropMenu', { static: true }) dropMenu: ElementRef;
	accept: string;
	pattern: string;
	filter: string;
	maxFileSize = 100;
	isModalShown = Boolean(false);
	isModalYoutubeShown = Boolean(false);
	modalHeight = Number(window.innerHeight * 0.9);
	importUrl;
	validYouTube = Boolean(false);
	isDropup = Boolean(false);

	constructor(
		private files: FilesManagerService,
		private overlay: OverlayService,
		private elRef: ElementRef,
		private cs: ComponentService
	) {}

	ngOnInit() {
		switch (this.allowedType) {
			case 'images':
				this.accept = '.jpg,.jpeg,.gif,.png';
				this.pattern = '.jpg,.jpeg,.JPG,.JPEG,.gif,.GIF,.png,.PNG';
				this.filter = 'image';
				break;
			case 'fonts':
				this.accept = '.ttf,.otf';
				this.pattern = '.ttf,.TTF,.otf,.OTF';
				this.filter = 'font';
				break;
			case 'videos':
				this.accept = '.mp4';
				this.pattern = '.mp4,.MP4';
				this.filter = 'video';
				break;
			case 'csv':
				this.accept = '.csv';
				this.pattern = '.csv,.CSV';
				this.filter = 'csv';
				break;
		}
	}

	hidedropMenu() {
		this.dropMenu.nativeElement.classList.remove('show');
	}

	uploadFile(event): boolean | void {
		const fileList: FileList = event.target.files;
		if (fileList.length === 0) {
			return false;
		}

		const file: File = fileList[0];
		this.overlay.updateOverlay(true, 'Uploading file...');
		this.files.uploadFile(file).subscribe((res) => {
			this.overlay.updateOverlay(false);
			if (res['status']) {
				if (this.filter === 'image') {
					const url = String(res && res.data);
					this.getImgDimensions(url);
				} else {
					this.onModelChange.emit({ url: res && res.data });
				}
			} else {
				this.overlay.updateOverlay(true, res['data'], 'alert');
			}
		});
	}

	getImgDimensions(url: string) {
		const img: HTMLImageElement = new Image();
		const _this = this;

		img.onload = function (e) {
			let width: number = img && img.naturalWidth ? img.naturalWidth : img.width;
			let height: number = img && img.naturalHeight ? img.naturalHeight : img.height;
			const isImgSizeValid = Boolean(width <= IMAGE_UPLOAD_MAX_SIZE && height <= IMAGE_UPLOAD_MAX_SIZE);

			if (isImgSizeValid) {
				_this.onModelChange.emit({ url, width, height });
			} else {
				// clean the image url/width/height in case of invalid image size
				width = 0;
				height = 0;
				url = '';
				_this.onModelChange.emit({ url, width, height });
				_this.overlay.updateOverlay(true, `The maximum size image is ${IMAGE_UPLOAD_MAX_SIZE}px.`, 'alert');
			}
		};

		// img.onerror = function (e) {
		//   _this.overlay.updateOverlay(true, e.error, 'alert');
		// };

		img.src = url;
	}

	handleOutput(event) {
		switch (event.method) {
			case 'selected': {
				this.getImgDimensions(event.url);
				this.fileManagerModal.hide();
				this.onModelChange.emit({ url: event.url, width: event.width, height: event.height });
				break;
			}

			default: {
				break;
			}
		}
	}

	checkYouTubeValid(): void {
		this.validYouTube =
			this.importUrl.search('youtube.com') !== -1 && (this.importUrl.search('embed') !== -1 || this.importUrl.search('v=') !== -1);
	}

	importFile() {
		if (this.validYouTube) {
			this.onModelChange.emit({ url: this.importUrl });
			this.isModalYoutubeShown = false;
		}
	}

	onDropdownShown(event) {
		const elemTop: number = this.elRef.nativeElement.getBoundingClientRect().top;
		this.isDropup =
			this.formScrollProp &&
			this.formScrollProp.hasOwnProperty('clientHeight') &&
			this.formScrollProp.clientHeight &&
			this.formScrollProp.clientHeight <= elemTop + FILE_UPLOAD_DROPDOWN_MAX_HEIGHT;
	}
}
